import React from 'react'
import './NewHeader.css'

const NewHeader = () => {
  return (
    <header>
        <div className="header-container">
            <h1 className="header-title">WEBHARVESTER AGENCY</h1>

            <h1 className="header-title2">Your Ultimate  Digital Marketing Partner</h1>

            <p className="header-des">WebHarvester Agency is a leading digital marketing agency that specializes in providing high-quality B2B lead generation services. With a strong Fiverr track record since 2020, we also offer data entry and web research services.</p>

            <a className="view-services-link" href="#services">View All Services</a>
        </div>
    </header>
  )
}

export default NewHeader;